<template>
    <main id="main">
        <div class="privacy-policy">
            <BackgroundImage image="privacy-policy" height="50" />
            <div class="container">
                <div class="privacy-policy__header">
                    <h2>Hantering av <span>personuppgifter</span></h2>
                </div>
                <div class="privacy-policy__content">
                    <h3>Personuppgiftspolicy</h3>
                    <p>
                        RetailOnly i Sverige AB (”RetailOnly”) är
                        personuppgiftsansvarig när personuppgifter som rör dig
                        behandlas. Denna policy informerar om behandling av
                        personuppgifter i samband med att en användare besöker
                        RetailOnlys webbplats eller köper en produkt eller en
                        tjänst av RETAILONLY.
                    </p>
                    <h4>Varför personuppgifter behandlas</h4>
                    <p>
                        Användaren kommer att behöva uppge uppgifter om
                        användarens företag och användaren själv. RETAILONLY
                        behandlar uppgifter som är nödvändiga för att
                    </p>
                    <ul>
                        <li>
                            kontrollera användares identitet i egenskap av
                            köpare av RetailOnlys produkter
                        </li>
                        <li>
                            erbjuda användare service på webbplats samt under
                            och efter köp
                        </li>
                        <li>
                            erbjuda användare befintliga eller nya tjänster och
                            produkter
                        </li>
                        <li>ingå avtal</li>
                        <li>
                            tillhandahålla fakturor och annat
                            beställningsunderlag
                        </li>
                        <li>
                            tillhandahålla nyhetsbrev och annan marknadsföring
                        </li>
                    </ul>
                    <p>
                        Det främsta syftet med att behandla uppgifter är att
                        kunna erbjuda anpassade och kvalitativa tjänster med
                        relevant innehåll. Uppgifterna används för att ge dig
                        den information eller de tjänster som efterfrågas och
                        för att förstå behoven bättre.
                    </p>
                    <p>
                        Om användare ger RETAILONLY sitt samtycke behandlar
                        RETAILONLY även användarens uppgifter för att kunna
                        tillhandahålla nyhetsbrev och annan marknadsföring om
                        produkter och tjänster. När användare inte längre önskar
                        ta del av en viss marknadsföringsåtgärd så har
                        användaren rätt att när om helst återkalla sitt
                        samtycke.
                    </p>
                    <h4>Typer av personuppgifter som behandlas</h4>
                    <p>
                        För att ovanstående ändamål ska kunna uppnås behövs
                        följande uppgifter:
                    </p>
                    <ul>
                        <li>företagsnamn</li>
                        <li>organisationsnummer</li>
                        <li>faktureringsadress</li>
                        <li>adress för annan post</li>
                        <li>förnamn på användare</li>
                        <li>efternamn på användare</li>
                        <li>e-postadress på användare samt</li>
                        <li>telefonnummer till användare</li>
                    </ul>
                    <h4>Vid besök av webbplatsen</h4>
                    <p>
                        När användare besöker webbplatsen, kan RETAILONLY bara
                        identifiera IP-adressen på datorn varifrån anropet till
                        webbplatsen görs. Trots dessa uppgifter förblir
                        användaren anonym, om användaren inte själv väljer att
                        lämna uppgifter som kan identifiera användaren,
                        exempelvis genom att köpa RetailOnlys produkter,
                        registrera sig, skicka e-postmeddelanden till RETAILONLY
                        eller om användaren på annat sätt väljer att lämna
                        uppgifter om sig själv eller sin verksamhet. Väljer
                        användare att lämna upplysningar som identifierar
                        användaren, samlar RETAILONLY in dem för användning inom
                        företaget, för de syften som anges i denna policy.
                    </p>
                    <p>
                        Vidare kan RETAILONLY, i likhet med de flesta andra
                        organisationer, påkalla nedläggning av så kallade
                        cookies på en användares hårddisk från vissa av
                        webbplatsens sidor. En cookie är en liten textfil som
                        läggs på användarens hårddisk och fungerar som
                        användarens ”ID-kort” på webbplatsen. Den är unik för
                        användaren, men innehåller inte information som
                        identifierar besökande människa personligen och kan
                        endast läsas av servern som skickade den. Cookien gör,
                        bland annat, att en användare enkelt kan navigera på
                        webbplatsen. Syftet är att berätta för RetailOnlys
                        server att användaren har återvänt till en viss
                        webbsida. Det sparar tid för användaren, eftersom om
                        användaren gjort en personlig utformning av sidor eller
                        registrerat sig för att få tillgång till vissa delar av
                        webbplatsen, så hjälper en cookie webbplatsen att komma
                        ihåg vem användaren är.
                    </p>
                    <h4>Rättslig grund för behandling av personuppgifter</h4>
                    <p>
                        RETAILONLY behandlar personuppgifterna i syfte att kunna
                        fullgöra eller ingå avtal med användaren. Det innebär
                        att RETAILONLY behandlar de personuppgifter som krävs
                        för att kunna uppnå de ovan nämnda ändamålen med
                        behandlingen. Det är nödvändigt för RETAILONLY att
                        behandla de ovan nämna kategorierna av personuppgifter
                        för att avtal ska kunna ingås eller fullgöras. Utan de
                        efterfrågade uppgifterna är det inte möjligt för
                        RETAILONLY att tillhandahålla RetailOnlys tjänster och
                        produkter.
                    </p>
                    <p>
                        RETAILONLY begär samtycke för att kunna erbjuda
                        användare vårt nyhetsbrev och annan marknadsföring.
                        RETAILONLY lämnar inte ut personuppgifter till andra
                        organisationer i marknadsföringssyfte. När användare
                        inte längre önskar att ta del av en viss
                        marknadsföringsåtgärd har användaren rätt att när om
                        helst återkalla sitt samtycke.
                    </p>
                    <h4>Lagring av personuppgifter</h4>
                    <p>
                        RETAILONLY lagrar användarens personuppgifter under så
                        lång tid som krävs för att fullgöra eller ingå avtal med
                        användaren. Det innebär att personuppgifter lagras under
                        den tid användaren är registrerad som användare av olika
                        tjänster hos RETAILONLY. Om användaren endast givit sitt
                        samtycke till viss marknadsföringsåtgärd så kommer
                        uppgifterna att behandlas under den tid samtycket
                        gäller.
                    </p>
                    <h4>Utlämnande av personuppgifter</h4>
                    <p>
                        RETAILONLY skänker inte bort, säljer eller hyr ut
                        personuppgifter om kunder och användare till tredje
                        part.
                    </p>
                    <p>
                        RETAILONLY kan i särskilda fall lämna ut en användares
                        uppgifter om det är nödvändigt för att bevaka,
                        fastställa och utöva rättsliga anspråk. Det kan bland
                        annat ske när det finns skäl att tro att uppgifterna är
                        nödvändiga för att identifiera, kontakta eller föra
                        talan mot någon som kan ha gjort intrång på webbplatsen
                        och/eller brutit mot användaravtalet, eller som på annat
                        vis gjort intrång eller inkräktar på RetailOnlys
                        rättigheter eller egendom, eller andra användares olika
                        rättigheter.
                    </p>
                    <h4>Användares rättigheter</h4>
                    <p>
                        Användare har rätt att när som helst ta kontakt med
                        RETAILONLY i syfte att utöva sina rättigheter enligt
                        gällande dataskyddslagstiftning.
                    </p>
                    <p>
                        Användare har rätt att när som helst ta kontakt med
                        RETAILONLY för att kontrollera att uppgifter kring
                        användaren är korrekta.
                    </p>
                    <p>
                        Användare har rätt att få ett registerutdrag där det
                        framgår vilka personuppgifter kring användarens som
                        behandlas.
                    </p>
                    <p>
                        Användare har rätt att få felaktiga uppgifter kring
                        användaren rättade eller kompletterade.
                    </p>
                    <p>
                        Användare har rätt att under vissa förutsättningar få
                        uppgifter kring användaren raderade, exempelvis om
                        uppgifterna är felaktiga. Beroende på vilken eller vilka
                        personuppgifter som raderas är det inte säkert att
                        RETAILONLY längre kan tillhandahålla vissa tjänster till
                        användaren.
                    </p>
                    <p>
                        Användare har rätt att få information om hur behandling
                        sker av användarens personuppgifter. Det sker i och
                        genom denna personuppgiftspolicy, så att en användare
                        vet hur personuppgifter avses bli behandlade, före det
                        att användaren ingår ett avtal med RETAILONLY. Om det
                        sker några förändringar i behandlingen av användares
                        personuppgifter kommer användaren att informeras om det.
                    </p>
                    <p>
                        Användare har rätt till begränsning av
                        personuppgifterna. I sådant fall får behandling av
                        användarens personuppgifter endast ske för vissa
                        avgränsade syften.
                    </p>
                    <p>
                        Användare har rätt till dataportabilitet, vilket innebär
                        en rätt att få personuppgifterna i ett strukturerat,
                        allmänt använt och maskinläsbart format.
                    </p>
                    <p>
                        Användare har rätt att när som helst inge klagomål till
                        Datainspektionen gällande behandlingen av användarens
                        personuppgifter.
                    </p>
                </div>
            </div>
        </div>
    </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'

export default defineComponent({
    name: 'Start',
    components: {
        BackgroundImage,
    },
})
</script>

<style lang="scss" scoped>
@import '../styles/mixins';

.privacy-policy {
    position: relative;

    &__header {
        height: 50vh;
        padding-top: 25vh;
        position: relative;
        z-index: 10;
        text-align: center;
    }

    &__content {
        padding: 6rem 2rem;

        @include mQ(550px) {
            padding: 3rem 0;
        }

        p,
        ul {
            margin-bottom: 2rem;
        }

        ul {
            padding: 0 2rem;
        }
    }
}
</style>
